import { appConfig } from '../../../../config'
import type { GetWeekTimeSlotsParams, WeekTimeSlotsResponse, HealthCallTimeslot } from './types'

export const getWeekTimeSlots = async ({
  accessToken,
  fromDate,
  toDate,
}: GetWeekTimeSlotsParams): Promise<WeekTimeSlotsResponse> => {
  const params = new URLSearchParams({
    fromDate,
    toDate,
  })

  const res = await fetch(`${appConfig.serverRootUrl}/api/private/healthCalls/timeslots?${params.toString()}`, {
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  })

  if (!res.ok) {
    const data = await res.json().catch(() => ({}))
    throw new Error(data?.message || 'Failed to fetch available timeslots')
  }

  const backendSlots: HealthCallTimeslot[] = await res.json()

  if (!Array.isArray(backendSlots)) {
    throw new Error('Invalid response format: expected array of timeslots')
  }

  backendSlots.forEach((slot, index) => {
    if (!slot.id || !slot.date || !slot.startTime || !slot.endTime) {
      throw new Error(`Invalid slot at index ${index}: missing required fields`)
    }
  })

  // Transform backend response to frontend format
  // Backend returns flat array with separate date and time fields in local Swedish time
  const transformedSlots = backendSlots.map((slot) => ({
    id: slot.id,
    startTime: `${slot.date}T${slot.startTime}:00.000`,
    endTime: `${slot.date}T${slot.endTime}:00.000`,
    specialistId: slot.specialistId,
  }))

  return {
    weekStart: fromDate,
    weekEnd: toDate,
    slots: transformedSlots,
  }
}
